import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function DeviceCreatePage() {
  const [formData, setFormData] = useState({
    device_name: "",
    imei: "",
    status: "available",
    price: "",
  });
  const [submitStatus, setSubmitStatus] = useState({ message: "", type: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://installmentzone.com/api";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (submitStatus.message) setSubmitStatus({ message: "", type: "" });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ message: "", type: "" });

    if (!formData.device_name.trim()) {
      toast.error("Device Name is required.");
      setIsSubmitting(false);
      return;
    }
    if (!formData.imei.trim() || formData.imei.trim().length < 15) {
      toast.error("A valid IMEI (at least 15 digits) is required.");
      setIsSubmitting(false);
      return;
    }

    try {
      const payload = { ...formData };
      if (payload.price !== "" && payload.price !== null) {
        payload.price = parseFloat(payload.price);
        if (isNaN(payload.price)) {
          toast.error("Price must be a valid number.");
          setIsSubmitting(false);
          return;
        }
      } else if (payload.price === "") {
        delete payload.price;
      }

      const response = await fetch(`${API_BASE_URL}/devices/create.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const resultText = await response.text();
      let result;
      try {
        result = JSON.parse(resultText);
      } catch {
        throw new Error(`Server returned invalid JSON: ${resultText}`);
      }

      if (!response.ok) throw new Error(result.error || `HTTP ${response.status}`);

      if (result.success) {
        toast.success(`Device "${formData.device_name}" added successfully!`);
        setTimeout(() => navigate("/devices"), 2000);
      } else {
        toast.error(result.error || "Failed to create device.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Network or server error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <ToastContainer theme="dark" />

      <div
        style={{
          background: "rgba(255,255,255,0.15)",
          padding: "30px",
          borderRadius: "15px",
          maxWidth: "550px",
          width: "100%",
          boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
          color: "#1E293B",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "26px",
            fontWeight: "600",
            color: "#fff",
            marginBottom: "25px",
          }}
        >
          Add New Device
        </h2>

        <form onSubmit={handleFormSubmit} noValidate>
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="device_name"
              style={{ display: "block", fontWeight: "600", marginBottom: "6px", color: "#fff" }}
            >
              Device Name:
            </label>
            <input
              type="text"
              id="device_name"
              name="device_name"
              value={formData.device_name}
              onChange={handleInputChange}
              required
              placeholder="e.g., iPhone 15 Pro"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #CBD5E1",
                fontSize: "1rem",
              }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="imei"
              style={{ display: "block", fontWeight: "600", marginBottom: "6px", color: "#fff" }}
            >
              IMEI:
            </label>
            <input
              type="text"
              id="imei"
              name="imei"
              value={formData.imei}
              onChange={handleInputChange}
              required
              minLength="15"
              maxLength="17"
              placeholder="15-17 digits"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #CBD5E1",
                fontSize: "1rem",
              }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="status"
              style={{ display: "block", fontWeight: "600", marginBottom: "6px", color: "#fff" }}
            >
              Status:
            </label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #CBD5E1",
                fontSize: "1rem",
              }}
            >
              <option value="available">Available</option>
              <option value="assigned_to_agent">Assigned to Agent</option>
              <option value="assigned_to_customer">Assigned to Customer</option>
              <option value="in_repair">In Repair</option>
              <option value="decommissioned">Decommissioned</option>
            </select>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="price"
              style={{ display: "block", fontWeight: "600", marginBottom: "6px", color: "#fff" }}
            >
              Price (Optional):
            </label>
            <input
              type="number"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              placeholder="0.00"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #CBD5E1",
                fontSize: "1rem",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "25px",
            }}
          >
            <button
              type="button"
              onClick={() => navigate("/devices")}
              disabled={isSubmitting}
              style={{
                background: "#DC2626",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                background: "#16A34A",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 20px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              {isSubmitting ? "Adding..." : "Add Device"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DeviceCreatePage;
